import apihelper from './apihelper'
import config from '../config'

var ua = window.navigator.userAgent.toLowerCase()

function qqMapTransBMap(lng, lat) {
  let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
  let x = lng;
  let y = lat;
  let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
  let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
  let lngs = z * Math.cos(theta) + 0.0065;
  let lats = z * Math.sin(theta) + 0.006;

  return {
    lng: lngs,
    lat: lats
  }
}

function bMapToQQMap(lng, lat) {

  if (lng == null || lng == '' || lat == null || lat == '')
    return [lng, lat];

  var x_pi = 3.14159265358979324;
  var x = parseFloat(lng) - 0.0065;
  var y = parseFloat(lat) - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
  var lng = (z * Math.cos(theta)).toFixed(7);
  var lat = (z * Math.sin(theta)).toFixed(7);

  return [lng, lat];

}

export default {
  oauth(p) {
    return apihelper.get(`/wx/oauth?code=${p}`)
  },
  getSign(url, apis, taglist) {
    return new Promise((reslove, reject) => {
      // var d = { "ticket": "LIKLckvwlJT9cWIhEQTwfMNt5xPTfSJo5v3zDMNf1Buj7iPYZ6Lj2H3zicY7hiE6S75HIl1qIQ5LwVZwDpi-8A", "timestamp": "6389655183", "nonceStr": "9a4d8854-2d18-44ea-ae52-600d43cb4c72", "appid": "wx961de68d82e9c6b1", "signature": "245CC95AD11C67C5F626D1777E1453DFCEDF7E9E" }
      return apihelper.get(`/Common/GetWXJSSign?url=${url}`).then((res) => {
        if (res.R) {
          config.wx.signUrl = url
          config.wx.signData = res

          var data = res.data;
          if (res.R) {
            config.wx.signUrl = url
            config.wx.signData = res

            var data = res.data;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: config.wx.appid, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: apis, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              openTagList: taglist || []
            })

            wx.ready(function () {
              wx.checkJsApi({
                jsApiList: apis,
                openTagList: taglist,
                success: function (resApi) {
                  reslove(resApi)
                }
              })
            })

            wx.error(function (resError) {
              reslove({})
            })
          }
          return res;
        }
      })
    })
  },
  async wx_config(taglist) {
    var apis = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'openLocation'];
    var url = encodeURIComponent(window.location.href.split('#')[0]);
    return await this.getSign(url, apis, taglist)
  },
  config(title, desc, url, imgurl) {
    if (!config.wx.isWX) {
      return
    }
    if (!title) {
      title = 'MAZ智能物联场景'
    }
    if (!desc) {
      desc = 'MAZ智能物联场景'
    }
    if (!url) {
      url = window.location.href
    }

    if (!imgurl) {
      imgurl = 'https://15.sunagy.com/favicon.ico';
    }

    var taglist = ["wx-open-launch-weapp"];
    this.wx_config(taglist).then((res) => {
      if (res.checkResult) {
        if (res.checkResult.onMenuShareTimeline) {
          wx.onMenuShareTimeline({
            title: title + '：' + desc, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgurl, // 分享图标
            success: function () {

            }
          })
        }
        if (res.checkResult.onMenuShareAppMessage) {
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc,
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgurl, // 分享图标
            success: function () {

            }
          })
        }
        if (res.checkResult.onMenuShareQQ) {
          wx.onMenuShareQQ({
            title: title, // 分享标题
            desc: desc,
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgurl, // 分享图标
            success: function () {

            }
          })
        }
        if (res.checkResult.onMenuShareWeibo) {
          wx.onMenuShareWeibo({
            title: title, // 分享标题
            desc: desc,
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgurl, // 分享图标
            success: function () {

            }
          })
        }
        if (res.checkResult.onMenuShareQZone) {
          wx.onMenuShareQZone({
            title: title, // 分享标题
            desc: desc,
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgurl, // 分享图标
            success: function () {

            }
          })
        }
      }
    })
  },
  openLocation(lat, lng, title, content) {
    // this.wx_config().then((res) => {
    //   if (res.checkResult) {
    //     if (res.checkResult.openLocation) {
    wx.openLocation({
      latitude: parseFloat(lat), // 纬度，浮点数，范围为90 ~ -90
      longitude: parseFloat(lng), // 经度，浮点数，范围为180 ~ -180。
      name: title, // 位置名
      address: content, // 地址详情说明
      scale: 17, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
    })
    //     }
    //   }
    // })
  },
  getLocation() {
    return new Promise((resolve, reject) => {
      var apis = ["getLocation"];
      this.wx_config(apis).then((res) => {
        if (res.checkResult) {
          if (res.checkResult.getLocation) {
            wx.getLocation({
              type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                var latitude = parseFloat(res.latitude); // 纬度，浮点数，范围为90 ~ -90
                var longitude = parseFloat(res.longitude); // 经度，浮点数，范围为180 ~ -180。
                var point = qqMapTransBMap(longitude, latitude);
                // console.log(point);
                resolve({
                  point: new BMap.Point(point.lng, point.lat)
                })
              }
            })
          }
        }
      })
    })
  },
  sanQRCode(type) {
    if (type == undefined) {
      type = 0;
    }
    var apis = ["scanQRCode"];
    return new Promise((resolve, reject) => {
      this.wx_config(apis).then((res) => {
        if (res.checkResult) {
          if (res.checkResult.scanQRCode) {
            return wx.scanQRCode({
              needResult: type, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success(res) {
                resolve(res);
              }
            })
          }
        }
      })
    })

  },
  chooseWXPay(data) {
    return new Promise((resolve, reject) => {
      var apis = ["chooseWXPay"];
      this.wx_config(apis).then((res) => {
        if (res.checkResult) {
          if (res.checkResult.chooseWXPay) {
            wx.chooseWXPay({
              timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.nonce_str, // 支付签名随机串，不长于 32 位
              package: data.package || data.package_, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.sign, // 支付签名
              success: function (res) {
                resolve(res);
              }
            });
          }
        }
      })
    })
  },
  openTag() {
    return new Promise((resolve, reject) => {
      var taglist = ["wx-open-launch-weapp"];
      this.wx_config(taglist).then((res) => {
        resolve(res);
      })
    })
  },
  bMapToQQMap: bMapToQQMap
}
